import { Button } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "../App.css";
import AudienceDonuts from "../components/AudienceDonuts";
import Calendar from "../components/Calendar";
import ViewersTable from "../components/ViewersTable";
import {
  setProduct,
  setReferences,
  setReferencesFilter,
} from "../redux/actions";
import {
  getMainProduct,
  getProduct,
  getProducts,
  getReferences,
} from "../redux/selectors";
import { useAppDispatch } from "../redux/store/hooks";

function Audience() {
  const dispatch = useAppDispatch();
  //dispatch(resetFeedFilter());
  const [loading, setLoading] = useState(true);
  const mainProduct = useSelector(getMainProduct);
  const products = useSelector(getProducts);
  const [competitors, setCompetitors] = useState([]);
  const references = useSelector(getReferences);

  useEffect(() => {
    if (products.length > 0 && mainProduct.id) {
      setLoading(true);
      let compArr: any = [];
      compArr = [
        ...products?.find((it: any) => it.id == mainProduct?.id)?.competitor,
      ];
      console.log(compArr);
      setCompetitors(compArr);
      setLoading(false);
    }
  }, [products, mainProduct]);

  return (
    <div className="App">
      <h1>Аудитория</h1>
      <Calendar />
      <div className="btn-group">
        <Button
          type={references == mainProduct?.client?.id ? "primary" : "default"}
          onClick={() => {
            dispatch(setReferences([mainProduct?.client?.id]));
            dispatch(setReferencesFilter([mainProduct?.client?.id]));
            dispatch(setProduct(mainProduct?.id));
          }}
        >
          {mainProduct?.client?.title}
        </Button>
        {competitors
          ?.sort((a: any, b: any) => a.title.localeCompare(b.title))
          ?.map((competitor: any, id) => (
            <Button
              key={id}
              type={references == competitor?.id ? "primary" : "default"}
              onClick={() => {
                dispatch(setReferences([competitor?.id]));
                dispatch(setReferencesFilter([competitor?.id]));
                dispatch(
                  setProduct(
                    products.find((it: any) => it?.client?.id == competitor?.id)
                      ?.id
                  )
                );
              }}
            >
              {competitor?.title}
            </Button>
          ))}
      </div>
      <AudienceDonuts />
      <ViewersTable />
    </div>
  );
}

export default Audience;
